import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "o-home" }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { class: "o-home__banner" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "a-section"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_no_posts_feedback = _resolveComponent("no-posts-feedback")!
  const _component_the_loader = _resolveComponent("the-loader")!
  const _component_page_header = _resolveComponent("page-header")!
  const _component_the_posts = _resolveComponent("the-posts")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.noPosts)
      ? (_openBlock(), _createBlock(_component_no_posts_feedback, {
          key: 0,
          title: ''
        }))
      : (!_ctx.pagePhoto)
        ? (_openBlock(), _createBlock(_component_the_loader, {
            key: 1,
            "page-loader": ""
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_page_header, {
              home: "",
              photoUrl: _ctx.pagePhoto
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("img", {
                    src: `${_ctx.basePath}/wp-content/uploads/2022/06/baner-1024x126-1.png`,
                    alt: "",
                    class: "o-home__bannerImage a-image"
                  }, null, 8, _hoisted_4)
                ])
              ]),
              _: 1
            }, 8, ["photoUrl"]),
            (_ctx.isLoading)
              ? (_openBlock(), _createBlock(_component_the_loader, {
                  key: 0,
                  py60: ""
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_the_posts, { routerPath: '/' })
                ]))
          ]))
  ]))
}